import * as React from 'react';
import { ItemScheme } from '../MagicFormItem';

interface MagicFieldImageProps {
	itemScheme: ItemScheme;
}

const MagicFieldImage: React.FC<MagicFieldImageProps> = props => {
	const { itemScheme } = props;

	return <img src={itemScheme?.value} />;
};

export default MagicFieldImage;
